import AppStyledTemplate from "App/appStyledTemplate";
import api from "Common/api/api";
import Button from "Components/button/button";
import ColorStyledBlock, { AREA } from "Components/colorStyledBlock";
import classNames from "classnames";
import TextWidget from "Components/optionForm/widgets/textWidget";
import React, { useEffect, useState } from "react";
import locale from "./page.locale";
import { isAxiosError } from "axios";
import { setCookieClientAuth } from "Common/cookies";
import paths from "paths";
import styles from "./LoginPage.module.css";
import logo from "Content/images/logo/HunterLogoFull.svg";
import lineImage from "Content/images/Auth/bg-img.svg";
import removeInitLoader from "Common/loader/removeInitLoader";
const coloredAreas = [AREA.TEXT];
export const SIZES = {
    FORM_WIDTH: 360,
    FORM_MIN_HEIGHT: 350,
    BRAND_MARGIN_BOTTOM: 40,
    ERROR_CONTAINER_MIN_HEIGHT: 60
};
const ENV_SAAS = process.env.SAAS_MODE === "true";
export default function LoginPage(props) {
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [error, setError] = useState(props.error || "");
    const [isProcessing, setIsProcessing] = useState(false);
    const handleSubmit = async (event) => {
        var _a, _b, _c, _d;
        event.preventDefault();
        setError("");
        setIsProcessing(true);
        try {
            let data;
            if (ENV_SAAS) {
                const response = await api.loginEmailApi({ email, password });
                data = response.data;
            }
            else {
                const response = await api.loginApi({ login, password });
                data = response.data;
            }
            if ((_a = data.Role) === null || _a === void 0 ? void 0 : _a.Permissions) {
                setCookieClientAuth({
                    Id: data.Id,
                    Login: data.Login,
                    Permissions: (_b = data.Role) === null || _b === void 0 ? void 0 : _b.Permissions
                });
            }
            window.location.href = paths.app;
        }
        catch (axiosError) {
            if (isAxiosError(axiosError)) {
                const errorMessage = ((_d = (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
                    (axiosError.response ? locale.UNKNOWN_ERROR : locale.NETWORK_ERROR);
                setError(errorMessage);
            }
            else {
                setError(locale.UNKNOWN_ERROR);
            }
        }
        finally {
            setIsProcessing(false);
        }
    };
    useEffect(() => {
        removeInitLoader();
    }, []);
    return (React.createElement(AppStyledTemplate, null,
        React.createElement("div", { className: styles["login-container"] },
            React.createElement("div", { className: styles.card },
                React.createElement("img", { src: logo, alt: "logo" }),
                React.createElement("form", { className: styles.form, onSubmit: handleSubmit, method: "post" },
                    React.createElement("div", { className: styles["input-group"] },
                        ENV_SAAS ? (React.createElement(TextWidget, { name: "Email", value: email, onChange: setEmail, label: locale.EMAIL, className: classNames(!!error && "error"), height: 44, mode: "email" })) : (React.createElement(TextWidget, { name: "Login", className: classNames(!!error && "error"), value: login, onChange: setLogin, label: locale.LOGIN, height: 44 })),
                        React.createElement(TextWidget, { mode: "password", name: "Password", value: password, onChange: setPassword, showPasswordEyeButton: true, className: classNames(!!error && "error"), label: locale.PASSWORD, height: 44 })),
                    React.createElement("div", { className: styles["error-container"] },
                        React.createElement(ColorStyledBlock, { className: `${!error && "invisible"}`, color: "brand-danger-500", areas: coloredAreas }, error)),
                    React.createElement("div", { className: styles["btn-login"] },
                        React.createElement(Button, { className: "btn-primary w-100", useSubmitBehavior: true, height: 44 }, isProcessing ? locale.LOADING : locale.SIGN_IN)))),
            React.createElement("img", { src: lineImage, className: styles["line-image"], alt: "" }))));
}
